import React, { useMemo } from "react";
import { Card, Row, Skeleton } from "antd";
import {
  CarOutlined,
  CreditCardOutlined,
  HomeOutlined,
  UserOutlined,
} from "@ant-design/icons";

import { useFetchConstant } from "apis/constant";
import { constructDisplayPrice, getLabelOfConstant } from "utils/general";

import {
  Description,
  LoanCard,
  Logo,
  Title,
  ProtectedStatus,
} from "./LoanCard.styles";
import Locale from "react-intl-universal";

const { Meta } = Card;
const LOAN_TYPE_LOGO = {
  mortgageLoan: <HomeOutlined />,
  investmentMortgageLoan: <HomeOutlined />,
  carLoan: <CarOutlined />,
  creditCardLoan: <CreditCardOutlined />,
  personalLoan: <UserOutlined />,
};

const CardDescription = ({ loanType, loanBalance, isProtected }) => {
  return (
    <>
      <Description>
        For <b>{loanType}</b>
      </Description>
      <Description>
        Loan left <b>{constructDisplayPrice(Number(loanBalance), false)}</b>
      </Description>
      <Row align="middle">
        <ProtectedStatus isProtected={isProtected}></ProtectedStatus>
        <Description>MRTA/MLTA</Description>
      </Row>
    </>
  );
};

const FinancialLoanCard = ({
  amount = 0,
  isProtected,
  loanBalance = 0,
  loanType,
  onEditClick,
  onDeleteClick,
}) => {
  const {
    isLoading: isLoanTypesLoading,
    selection: loanTypes,
  } = useFetchConstant("loanTypes");
  const loanTypeLabel = useMemo(
    () => (isLoanTypesLoading ? "" : getLabelOfConstant(loanType, loanTypes)),
    [isLoanTypesLoading, loanType, loanTypes]
  );

  return (
    <LoanCard
      actions={[
        <span onClick={onEditClick}>
          {Locale.get("addNewAdvisee.loanSection.edit")}
        </span>,
        <span onClick={onDeleteClick}>
          {Locale.get("addNewAdvisee.loanSection.remove")}
        </span>,
      ]}
    >
      <Skeleton loading={isLoanTypesLoading} avatar active>
        <Meta
          avatar={<Logo>{LOAN_TYPE_LOGO[loanType]}</Logo>}
          title={<Title>{constructDisplayPrice(Number(amount), false)}</Title>}
          description={
            <CardDescription
              loanType={loanTypeLabel}
              loanBalance={loanBalance}
              isProtected={isProtected}
            />
          }
        />
      </Skeleton>
    </LoanCard>
  );
};

export default FinancialLoanCard;
